module.exports = __webpack_public_path__ + "img/environmentalMonitoring01.b79f4c74.png";